import blueGrey from '@mui/material/colors/blueGrey'
import {ParentContext} from 'app/hooks/ApiParentContext'
import {CProject} from 'app/modules/discovery/core'
import {UseMutationResult} from 'react-query'
import {JsonData, JsonObject} from './types'

export const PTunselectedStepProps = {
  stepColor: `10px solid ${blueGrey[100]}`,
  bgColor: blueGrey[100],
}
export const PTselectedStepProps = {
  stepColor: `10px solid ${blueGrey[400]}`,
  bgColor: blueGrey[400],
}

export const PTlistSorted = (
  entityId: string,
  projectSteps: iProjectStepsState[],
  step: {
    displayName: string
    selected: boolean
    orderNo: number
  }
) => {
  const retval = projectSteps
    .find((f) => f.entityId === entityId)
    ?.steps.sort((x, y) => x.orderNo - y.orderNo)
  retval?.map((item, i) => {
    if (item.displayName === step.displayName) {
      item.selected = true
    } else {
      if (item.orderNo < step.orderNo) {
        item.selected = true
      } else {
        item.selected = false
      }
    }
  })
  return retval
}

export const PTPreviousStep = (
  entityId: string,
  projectSteps: iProjectStepsState[],
  step: {
    displayName: string
    selected: boolean
    orderNo: number
  }
) => {
  let previousStep = ''
  const stepsSorted = projectSteps
    .find((f) => f.entityId === entityId)
    ?.steps.sort((x, y) => x.orderNo - y.orderNo)

  stepsSorted?.map((item, i) => {
    if (item.displayName !== step.displayName) {
      previousStep = item.displayName
    }
  })
  return previousStep
}

export interface IProjectTypeFE {
  id: string
  display_name: string
  description?: string
  project_steps?: {id?: string; name?: string; description?: string}[]
  entity_steps?: {entity_type: string; steps: string[]}[]
}

interface iProjectSteps {
  displayName: string
  selected: boolean
  orderNo: number
}
export interface iProjectStepsState {
  entityId: string
  steps: iProjectSteps[]
}

export const ProjectTypesDS: readonly IProjectTypeFE[] = [
  {
    id: 'tech-scouting',
    display_name: 'Tech Scouting',
    description: 'Tech Scouting',
    project_steps: [
      {id: 'Considered', name: 'Considered', description: 'Considered'},
      {id: 'Evaluated', name: 'Evaluated', description: 'Evaluated'},
      {id: 'Down-Selected', name: 'Down-Selected', description: 'Down-Selected'},
      {id: 'Selected', name: 'Selected', description: 'Selected'},
    ],
    entity_steps: [
      {
        entity_type: 'award',
        steps: ['Considered', 'Evaluated', 'Down-Selected', 'Selected'],
      },
      {entity_type: 'business', steps: ['Considered', 'Evaluated', 'Down-Selected', 'Selected']},
      {entity_type: 'person', steps: ['Considered', 'Evaluated', 'Down-Selected', 'Selected']},
    ],
  },
  {
    id: 'market-research',
    display_name: 'Market Research',
    description: 'Market Research',
    project_steps: [
      {id: 'Considered', name: 'Considered', description: 'Considered'},
      {id: 'Selected', name: 'Selected', description: 'Selected'},
    ],
    entity_steps: [
      {entity_type: 'award', steps: ['Considered', 'Selected']},
      {entity_type: 'business', steps: ['Considered', 'Selected']},
      {entity_type: 'person', steps: ['Considered', 'Selected']},
    ],
  },
  {
    id: 'innovation',
    display_name: 'Innovation',
    description: 'Innovation',
    project_steps: [],
    entity_steps: [
      {entity_type: 'award', steps: ['Identified', 'Evaluated', 'Down-Selected', 'Selected']},
      {entity_type: 'business', steps: ['Identified', 'Evaluated', 'Down-Selected', 'Selected']},
      {entity_type: 'patent', steps: ['Identified', 'Evaluated', 'Down-Selected', 'Selected']},
      {entity_type: 'person', steps: ['Identified', 'Evaluated', 'Down-Selected', 'Selected']},
      {entity_type: 'faculty', steps: ['Identified', 'Evaluated', 'Down-Selected', 'Selected']},
      {
        entity_type: 'innovation',
        steps: ['Identified', 'Evaluated', 'Down-Selected', 'Selected'],
      },
      {
        entity_type: 'opportunity',
        steps: ['Identified', 'Selected', 'Proposed'],
      },
    ],
  },
]
//Identified, Evaluated, Downselected, Selected
export function PTgetProjectTypeSteps(
  project: CProject,
  fe_entity_type: string,
  be_entity_type: string
): iProjectStepsState[] {
  //take project type and get the
  const projType = ProjectTypesDS?.find((f) => f.id === project.project_type)
  const stepsForEntity = projType?.entity_steps?.find(
    (f) => f.entity_type === fe_entity_type
  )?.steps
  const projectsSteps: iProjectStepsState[] =
    // @ts-ignore
    project[be_entity_type]?.map((result: any, index: any) => {
      return {
        entityId: result.id ?? '',
        steps:
          stepsForEntity?.map((m, i) => {
            //if have a result.__step id, one is selected, each is selected prior to index greater than the __step_id
            if (result.__step_id && i <= stepsForEntity.indexOf(result.__step_id)) {
              return {displayName: m, selected: true, orderNo: i + 1}
            } else {
              return {displayName: m, selected: false, orderNo: i + 1}
            }
          }) ?? [],
      }
    }) ?? []

  return projectsSteps
}

export async function PThandleSetProjectSteps(
  entityId: string,
  repoHook: UseMutationResult<
    JsonData,
    unknown,
    {
      prop?: string | undefined
      parentId: string
      childId: string
      data?: JsonObject | undefined
      parentContext?: ParentContext | undefined
    },
    unknown
  >,
  project: CProject,
  updatedSteps: iProjectStepsState[],
  additionalHookArgs: {
    oldApi?: boolean
    overrideRoute?: string
  }
) {
  //update the step
  const updEntity = updatedSteps.find((f) => f.entityId === entityId)
  //get the step last true,
  let itemSel = ''
  updEntity?.steps?.map((m) => {
    if (m.selected) {
      itemSel = m.displayName
    }
  })
  if (project.id && updEntity?.entityId) {
    const allPromises = await PTsimplifiedUpdateCall(
      project.id,
      [updEntity.entityId],
      itemSel,
      repoHook,
      additionalHookArgs
    )

    return allPromises.length ? true : false
  }
  return false
}

//if you end up not getting a status chck that ProjectTypesDS is defined for the entity type along with the steps
//and the project has the correct types/entities, i. make sure something like opportunity entity is not on market-research etc.
//if market-rsearch is supposed to have opportuitiy entities or not
export const PTgetStatus = (entityId: string, projectSteps: iProjectStepsState[]) => {
  let i = 0
  let retval = ''
  const inList = projectSteps.find((f) => f.entityId === entityId)
  if (inList) {
    do {
      if (!inList.steps[i].selected) {
        i = inList.steps.length
        if (i === 0) {
          retval = inList.steps[i].displayName
        }
      } else {
        retval = inList.steps[i].displayName
      }
      i++
    } while (i < inList.steps.length)
  }
  return retval
}

const PTsimplifiedUpdateCall = async (
  projectId: string,
  resultIds: string[],
  StepName: string,
  repoHook: UseMutationResult<
    JsonData,
    unknown,
    {
      prop?: string | undefined
      parentId: string
      childId: string
      data?: JsonObject | undefined
      parentContext?: ParentContext | undefined
      oldApi?: boolean
      overrideRoute?: string
    },
    unknown
  >,
  additionalHookArgs: {
    oldApi?: boolean
    overrideRoute?: string
  }
) => {
  const promises: Promise<unknown>[] = []
  for (const resultId of resultIds) {
    promises.push(
      repoHook.mutateAsync({
        parentId: projectId,
        childId: resultId,
        data: {__step_id: StepName},
        oldApi: additionalHookArgs.oldApi,
        overrideRoute: additionalHookArgs.overrideRoute,
      })
    )
  }
  return await Promise.all(promises)
}
